import { render, staticRenderFns } from "./OktaSsoError.vue?vue&type=template&id=d5407afc"
import script from "./OktaSsoError.vue?vue&type=script&lang=ts"
export * from "./OktaSsoError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports